class TextProcessingService {
  constructor() {
    // Список фраз для удаления
    this.phrasesToRemove = [
      'ONLY AVAILABLE IN PAID PLANS',
      'Subscribe to see more',
      'This content is available only to subscribers',
      'Read more at',
      'Read the full article',
      'Click here to read more',
      'Sign up for our newsletter',
      'For more information, visit',
      'Подробнее на сайте',
      'Читать далее',
      'Подписывайтесь на наш канал',
      'Полный текст статьи доступен по подписке',
      'Доступно только в платных планах',
      'Зарегистрируйтесь, чтобы прочитать полную статью',
      'Для просмотра полного содержания необходима подписка'
    ];
    
    // Регулярные выражения для удаления
    this.regexPatterns = [
      // URL
      /https?:\/\/[^\s]+/g,
      // Email
      /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/g,
      // Телефонные номера (исправлено)
      /(\+\d{1,3}[\s-]?)?\d{3,4}[\s.-]?\d{3}[\s.-]?\d{2,4}/g
    ];
  }

  // Очистка текста от нежелательных фраз и шаблонов
  cleanText(text) {
    if (!text) return '';
    
    let cleanedText = text;
    
    // Удаляем каждую фразу
    for (const phrase of this.phrasesToRemove) {
      cleanedText = cleanedText.replace(new RegExp(phrase, 'gi'), '');
    }
    
    // Удаляем шаблоны по регулярным выражениям
    for (const regex of this.regexPatterns) {
      cleanedText = cleanedText.replace(regex, '');
    }
    
    // Удаляем лишние пробелы
    cleanedText = cleanedText.replace(/\s+/g, ' ').trim();
    
    return cleanedText;
  }
  
  // Расчет схожести двух текстов (коэффициент Жаккара)
  calculateSimilarity(text1, text2) {
    if (!text1 || !text2) return 0;
    
    // Функция для получения набора слов из текста
    const getWords = (text) => {
      return new Set(
        text.toLowerCase()
          .replace(/[.,\/#!$%\^&\*;:{}=\-_`~()]/g, '')
          .split(/\s+/)
          .filter(word => word.length > 3)
      );
    };
    
    // Получаем наборы слов
    const words1 = getWords(text1);
    const words2 = getWords(text2);
    
    // Если наборы пустые, возвращаем 0
    if (words1.size === 0 || words2.size === 0) return 0;
    
    // Находим пересечение наборов
    const intersection = new Set();
    for (const word of words1) {
      if (words2.has(word)) {
        intersection.add(word);
      }
    }
    
    // Вычисляем коэффициент Жаккара
    const similarity = intersection.size / (words1.size + words2.size - intersection.size);
    
    return similarity;
  }
  
  // Удаление HTML-тегов из текста
  removeHtmlTags(text) {
    if (!text) return '';
    return text.replace(/<[^>]*>/g, '');
  }
  
  // Обрезка текста до указанной длины с добавлением многоточия
  truncateText(text, maxLength = 200) {
    if (!text || text.length <= maxLength) return text;
    
    // Обрезаем текст до ближайшего пробела перед maxLength
    const truncated = text.substring(0, maxLength);
    const lastSpaceIndex = truncated.lastIndexOf(' ');
    
    if (lastSpaceIndex === -1) return truncated + '...';
    
    return truncated.substring(0, lastSpaceIndex) + '...';
  }
}

export default new TextProcessingService();
